import { useContext } from "react";
import { AuthContext, AuthContextType } from "../context";

/**
 * Hook for accessing authentication context
 * @returns Authentication context with user info, auth state and role checking
 * @throws Error if used outside of AuthProvider
 */
export const useAuth = (): AuthContextType => {
    const context = useContext(AuthContext);

    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }

    return context;
};
